import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../_virtual/_rollupPluginBabelHelpers.js';
import { readEndpoint, createEntity } from 'redux-json-api';
import { ActionTypes } from '../constants/actionTypes.js';
import { displayError, clearMessages } from './messagesActions.js';

var startDownload = function startDownload(type) {
  return {
    type: ActionTypes.START_DOWNLOAD,
    entityType: type
  };
};

var downloadSuccess = function downloadSuccess(downloadUrl) {
  return {
    type: ActionTypes.DOWNLOAD_SUCCESS,
    downloadUrl: downloadUrl
  };
};

var downloadFail = function downloadFail(errorMessage) {
  return {
    type: ActionTypes.DOWNLOAD_FAIL,
    errorMessage: errorMessage
  };
};

var reportTimeout = function reportTimeout() {
  return {
    type: ActionTypes.REPORT_TIMEOUT
  };
};

var endTimeout = function endTimeout() {
  return {
    type: ActionTypes.END_TIMEOUT
  };
};

var pollUrl = function pollUrl(_ref) {
  var interval = _ref.interval,
      max = _ref.max,
      getData = _ref.getData,
      checkComplete = _ref.checkComplete,
      onFinish = _ref.onFinish,
      onTimeout = _ref.onTimeout;
  var timer = 0;
  var poll = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var status;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(timer > max)) {
              _context.next = 5;
              break;
            }

            clearInterval(poll);
            onTimeout();
            _context.next = 10;
            break;

          case 5:
            timer += interval;
            _context.next = 8;
            return getData();

          case 8:
            status = _context.sent;

            if (checkComplete(status)) {
              clearInterval(poll);
              onFinish(status);
            }

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), interval);
  return poll;
};

var downloadReport = function downloadReport(type, attributes) {
  var pollInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
  var pollMax = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 11000;
  attributes.report_type = type;
  var dl = {
    type: 'reports',
    attributes: attributes
  };
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var create, report;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(startDownload());
              create = createEntity(dl);
              _context2.prev = 2;
              _context2.next = 5;
              return create(dispatch, getState);

            case 5:
              report = _context2.sent;
              dispatch(clearMessages());
              pollUrl({
                interval: pollInterval,
                max: pollMax,
                getData: function getData() {
                  return dispatch(readEndpoint("reports/".concat(report.data.id, "?report_type=").concat(type)));
                },
                checkComplete: function checkComplete(status) {
                  return status.data.attributes.status === 'completed';
                },
                onFinish: function onFinish(result) {
                  return dispatch(downloadSuccess(result.data.attributes.download_url));
                },
                onTimeout: function onTimeout() {
                  return dispatch(reportTimeout());
                }
              });
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](2);
              dispatch(displayError(_context2.t0));
              dispatch(downloadFail());

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 10]]);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var downloadHomeroomReport = function downloadHomeroomReport(url) {
  var pollInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var pollMax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 11000;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(startDownload());

              try {
                dispatch(clearMessages());
                pollUrl({
                  interval: pollInterval,
                  max: pollMax,
                  getData: function getData() {
                    return dispatch(readEndpoint(url));
                  },
                  checkComplete: function checkComplete(report) {
                    return !!report.download_url;
                  },
                  onFinish: function onFinish(result) {
                    return dispatch(downloadSuccess(result.download_url));
                  },
                  onTimeout: function onTimeout() {
                    return dispatch(reportTimeout());
                  }
                });
              } catch (e) {
                dispatch(displayError(e));
                dispatch(downloadFail());
              }

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var fetchReport = function fetchReport(id, type) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch) {
      var result;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dispatch(startDownload());
              _context4.prev = 1;
              _context4.next = 4;
              return dispatch(readEndpoint("reports/".concat(id, "?report_type=").concat(type)));

            case 4:
              result = _context4.sent;
              dispatch(downloadSuccess(result.data.attributes.download_url));
              _context4.next = 12;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              dispatch(displayError(_context4.t0));
              dispatch(downloadFail());

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 8]]);
    }));

    return function (_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};

export { downloadHomeroomReport, downloadReport, endTimeout, fetchReport, pollUrl };